var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.details
    ? _c(
        "div",
        {
          staticClass: "course-details",
        },
        [
          _c(
            "div",
            {
              staticClass: "semester",
            },
            [_vm._v("\n        (" + _vm._s(_vm.details.semester) + ")\n    ")]
          ),
          _vm._v(" "),
          _vm.details.admissionstate
            ? _c(
                "div",
                {
                  staticClass: "admission-state",
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: _vm.details.admissionstate.icon,
                      role: _vm.details.admissionstate.role,
                      alt: _vm.details.admissionstate.info,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "course-lecturers",
            },
            _vm._l(_vm.details.lecturers, function (lecturer, index) {
              return _c(
                "span",
                {
                  key: index,
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.profileUrl(lecturer.username),
                        title: _vm.$gettextInterpolate(
                          _vm.$gettext("Zum Profil von %{ user }"),
                          {
                            user: lecturer.name,
                          },
                          true
                        ),
                        tabindex: "0",
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(lecturer.name) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm.details.lecturers.length > 1 &&
                  index < _vm.details.lecturers.length - 1
                    ? [_vm._v(", ")]
                    : _vm._e(),
                ],
                2
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "MountingPortal",
            {
              attrs: {
                mountTo: "#course-dates-" + _vm.course,
                append: true,
              },
            },
            [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.details.dates),
                },
              }),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }